export default {
  title: 'Cambiar contraseña',
  form: {
    email: {
      label: 'Correo electrónico',
      placeholder: 'Introduce el correo',
    },
    new_password: {
      label: 'Nueva contraseña',
      placeholder: 'Introduce la contraseña',
      requirements: 'Tu contraseña debe tener 8 caracteres, una mayúscula y un número',
    },
    confirm_password: {
      label: 'Confirmación de nueva contraseña',
      placeholder: 'Confirmar contraseña',
    },
    error_messages: {
      missing_info: 'Información faltante',
    },
  },
  buttons: {
    change_password: 'Cambiar contraseña',
  },
};
